import { createSlice } from "@reduxjs/toolkit";
import { getAcquirerList } from "./Acquirer.thunk";

const baseState = {
  acquirerData: [],
  acquirerSelected: null,
  acquirerDataById: null,
  page: 1,
  pageSize: 5,
  totalPages: 0,
  totalRecords: 0,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const initialState = {
  ...baseState,
};

export const acquirerSlice = createSlice({
  name: "acquirer",
  initialState,
  reducers: {
    SetAcquirerSelected: (state, action) => {
      const { acquirerSelected } = action.payload;
      console.log("state ====>", state);
      console.log("action.payload ====>", action.payload);
      console.log("acquirerSelected ====>", acquirerSelected);
      state.acquirerSelected = acquirerSelected;
    },
    ResetDataFilteredByid: (state) => {
      state.acquirerDataById = null;
      state.status = "idle";
    },
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAcquirerList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAcquirerList.fulfilled, (state, action) => {
        const { acquirerData, page, page_size, total_pages, total_records } =
          action.payload;
        state.status = "succeeded";
        state.acquirerData = acquirerData;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
      })
      .addCase(getAcquirerList.rejected, (state, action) => {
        state.status = "failed";
        state.acquirerData = [];
        state.page = 1;
        state.pageSize = 5;
        state.totalPages = 0;
        state.totalRecords = 0;
        state.error =
          action?.payload?.message || "Error fetching acquirer list";
      });
  },
});

export const { ResetStore, SetAcquirerSelected, ResetDataFilteredByid } =
  acquirerSlice.actions;

export default acquirerSlice.reducer;
